/**
 * Converts a string to sentence case.
 * Example: "hello world. this is a test." => "Hello world. This is a test."
 */
export function toSentenceCase(input: string): string {
  return input
    ?.toLowerCase()
    .replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
}
/**
 * Converts an ALL_CAPS_UNDERSCORE string to Title Case with spaces.
 * Example: "IN_PROGRESS" => "In Progress"
 */
export function toTitleCase(input: string): string {
  return input
    ?.toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
